import { Navigate } from 'react-router-dom';
import { forbidden, notFound, RouteConfig } from '.';
import RouteWithPageTitle from './RouteWithPageTitle';
import { useAccountAuthenticate } from './useAccountAuthenticate';

const ProtectedAccountRoute = (props: RouteConfig) => {
  const {
    isAccountAuthenticated,
    redirectToForbidden,
    redirectToNotFound,
    redirectToUpgradeBlockedForbidden,
  } = useAccountAuthenticate(props);
  if (isAccountAuthenticated) {
    return <RouteWithPageTitle {...props} />;
  }
  if (redirectToUpgradeBlockedForbidden) {
    return <Navigate to={`${forbidden.path}?upgradeBlocked=true`} replace />;
  }
  if (redirectToForbidden) {
    return <Navigate to={forbidden.path} replace />;
  }
  if (redirectToNotFound) {
    return <Navigate to={notFound.path} replace />;
  }
  return <></>;
};

export default ProtectedAccountRoute;
